module.exports = __webpack_public_path__ + "img/footer-logo.b06d8b76.svg";